<template>
  <div>
    <div class="container ny_content">
      <div class="ny_nav">
        <div class="ny_nav_h">
          <div>
            <h2>关于我们</h2>
            <p>ABOUT US</p>
          </div>
        </div>
        <div class="ny_nav_dqwz">
          当前位置：<span class="hidden-xs">关于我们></span>企业文化
        </div>
      </div>
      <div class="ny_view">
        <div class="ny_qywh">
          <div class="ny_qywh_content">
            <div class="qywh_cell" v-for="(item,index) in cultureList.moreNotifyObject" :key="index">
              <div class="qywh_desc">
                <h3>{{item.title}}</h3>
                <p>{{item.desc}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data(){
    return{
      cultureList:[]
    }
  },

  created () {
      this.getCultureList()
  },
  methods:{
    async getCultureList(){
      const {data:res} = await this.$http.get('home/culture_list');
      if (res.code !== 200) return false
      this.cultureList = res.data.content
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/about/culture/index.vue